import { createFileRoute } from '@tanstack/react-router';

import { RolesPage } from '@/areas/settings/OrganizationSettings/pages/RightsManagement/RolesPage';
import { canViewAdvancedUserManagement } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/organization/user-management/roles')({
    staticData: { access: { permissions: canViewAdvancedUserManagement }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <RolesPage />;
}
